'use strict';

const genOptions = (strings) => {
    return strings.map((s) => {
        return {
            label: s,
            value: s.toLowerCase().replace(/[-. /]+/g, '-'),
            code: s.toLowerCase().replace(/[-. /]+/g, '-')
        };
    });
};

const genReasonOptions = (arr) => {
    return arr.map((obj) => ({
        label: obj.label,
        value: obj.label.toLowerCase().replace(/[. /]+/g, '-'),
        code: obj.label.toLowerCase().replace(/[. /]+/g, '-'),
        level: obj.level
    }));
};

// General dictionaries, used in PDF reports
const origins = ['Inbound', 'Outbound'];

const reasons = [
    {
        level: 1,
        label: 'Returned Call'
    },
    {
        level: 1,
        label: 'Education'
    },
    {
        level: 1,
        label: 'Enrollment'
    },
    {
        level: 1,
        label: 'Insurance'
    },
    {
        level: 1,
        label: 'Medications'
    },
    {
        level: 1,
        label: 'Post Acute Follow Up'
    },
    {
        level: 1,
        label: 'Referral'
    },
    {
        level: 1,
        label: 'Routine Check In'
    },
    {
        level: 1,
        label: 'Scheduling'
    },
    {
        level: 1,
        label: 'Symptom Follow Up'
    },
    {
        level: 1,
        label: 'Symptoms Urgent'
    },
    {
        level: 1,
        label: 'Chase Call'
    },
    {
        level: 1,
        label: 'Symptoms Routine'
    },
    {
        level: 1,
        label: 'Initial Assessment'
    },
    {
        level: 1,
        label: 'BH Coaching'
    },
    {
        level: 2,
        label: 'Other / No Reason'
    }
];

const dispositions = [
    {
        level: 1,
        label: 'Success'
    },
    {
        level: 1,
        label: 'Left Message'
    },
    {
        level: 1,
        label: 'Left Voicemail'
    },
    {
        level: 1,
        label: 'Req. Call back'
    },
    {
        level: 1,
        label: 'No Answer'
    },
    {
        level: 1,
        label: 'Hospitalized'
    },
    {
        level: 1,
        label: 'Post Acute Care'
    },
    {
        level: 1,
        label: 'Wrong/Non-working No'
    },
    {
        level: 2,
        label: 'Other'
    }
];

const successOnly = [
    {
        label: 'Success'
    }
];

const reasonsPhoneInbound = reasons.filter((r) => {
    return ![
        'Post Acute Follow Up',
        'Routine Check In',
        'Symptoms Follow Up'
    ].includes(r.label);
});

const reasonsPhoneOutbound = reasons.filter((r) => {
    return ![
        'Returned Call',
        'Success',
        'Symptoms Urgent',
        'Symptoms Routine'
    ].includes(r.label);
});

const reasonsHome = reasons.filter((r) => {
    return !['Returned Call', 'Enrollment'].includes(r.label);
});

const reasonsOther = successOnly;

// Dictionaries used in forms for disposition value
// eslint-disable-next-line no-unused-vars
const dispositionsPhoneOutbound = dispositions;
// eslint-disable-next-line no-unused-vars
const dispositionsOther = successOnly;

const phoneParticipantsWaitlistPlannedOnhold = genOptions([
    'Patient',
    'Healthjoy',
    'Other',
    'Provider',
    'Unsuccessful',
    'CuraLinc'
]);

const homeParticipantsWaitlistPlannedOnhold = genOptions([
    'Patient',
    'Other',
    'Unsuccessful'
]);

const phoneOutcomesWaitlistPlannedOnhold = {
    patient: genOptions([
        'Enrolled',
        'Hard Decline',
        'Soft Decline',
        'Requests Callback',
        'Will call us back',
        'Care Coordination',
        'Other'
    ]),
    healthjoy: genOptions([
        'Enrolled',
        'Hard Decline',
        'Soft Decline',
        'Requests Callback',
        'Will call us back',
        'Care Coordination',
        'Other'
    ]),
    other: genOptions([
        'Requests Callback',
        'Will call us back',
        'Requests no further calls',
        'Care Coordination',
        'Other'
    ]),
    provider: genOptions([
        'Caller Referred',
        'Requests Callback',
        'Will call us back',
        'Care Coordination',
        'Other'
    ]),
    unsuccessful: genOptions([
        'Left Voicemail',
        'Hung Up',
        'No Answer',
        'Wrong Number',
        'Non-working Number',
        'Care Coordination',
        'Other'
    ]),
    vendor: genOptions([
        'Requests Callback',
        'Will Call Us Back',
        'Care Coordination',
        'Unable to Leave Message'
    ])
};

const homeOutcomesWaitlistPlannedOnhold = {
    healthjoy: genOptions([
        'Enrolled',
        'Hard Decline',
        'Soft Decline',
        'Undecided - Requests return visit',
        'Undecided - Will contact us for new visit',
        'Other'
    ]),
    patient: genOptions([
        'Enrolled',
        'Hard Decline',
        'Soft Decline',
        'Undecided - Requests return visit',
        'Undecided - Will contact us for new visit',
        'Other'
    ]),
    other: genOptions([
        'Requests return visit',
        'Will contact us for new visit',
        'Requests no further visits',
        'Other'
    ]),
    unsuccessful: genOptions([
        "Didn't answer door",
        'Patient and/or representative unavailable',
        'Wrong address',
        'Wrong Number',
        'Schedule Error',
        'Other'
    ]),
    vendor: genOptions([
        'Requests Callback',
        'Will Call Us Back',
        'Care Coordination',
        'Unable to Leave Message'
    ])
};

module.exports = {
    origins: genOptions(origins),
    reasons: genReasonOptions(reasons),

    reasonsHome: genReasonOptions(reasonsHome),
    reasonsPhoneInbound: genReasonOptions(reasonsPhoneInbound),
    reasonsPhoneOutbound: genReasonOptions(reasonsPhoneOutbound),
    reasonsOther: genReasonOptions(reasonsOther),

    participants: {
        phone: {
            waitlist: phoneParticipantsWaitlistPlannedOnhold,
            planned: phoneParticipantsWaitlistPlannedOnhold,
            onhold: phoneParticipantsWaitlistPlannedOnhold,
            active: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Other',
                'Provider',
                'Unsuccessful',
                'CuraLinc'
            ]),
            'entered-in-error': genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Other',
                'Provider',
                'Unsuccessful',
                'CuraLinc'
            ]),
            finished: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ]),
            expired: genOptions([
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ]),
            cancelled: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ])
        },
        mobile: {
            waitlist: phoneParticipantsWaitlistPlannedOnhold,
            planned: phoneParticipantsWaitlistPlannedOnhold,
            onhold: phoneParticipantsWaitlistPlannedOnhold,
            active: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Other',
                'Provider',
                'Unsuccessful',
                'CuraLinc'
            ]),
            'entered-in-error': genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Other',
                'Provider',
                'Unsuccessful',
                'CuraLinc'
            ]),
            finished: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ]),
            expired: genOptions([
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ]),
            cancelled: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ])
        },
        email: {
            waitlist: phoneParticipantsWaitlistPlannedOnhold,
            planned: phoneParticipantsWaitlistPlannedOnhold,
            onhold: phoneParticipantsWaitlistPlannedOnhold,
            active: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Other',
                'Provider',
                'Unsuccessful',
                'CuraLinc'
            ]),
            'entered-in-error': genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Other',
                'Provider',
                'Unsuccessful',
                'CuraLinc'
            ]),
            finished: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ]),
            expired: genOptions([
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ]),
            cancelled: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Provider',
                'Other',
                'Unsuccessful',
                'CuraLinc'
            ])
        },
        home: {
            waitlist: homeParticipantsWaitlistPlannedOnhold,
            planned: homeParticipantsWaitlistPlannedOnhold,
            onhold: homeParticipantsWaitlistPlannedOnhold,
            active: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Unsuccessful'
            ]),
            'entered-in-error': genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Unsuccessful'
            ]),
            finished: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Unsuccessful'
            ]),
            expired: genOptions(['Caregiver', 'Unsuccessful']),
            cancelled: genOptions([
                'Patient',
                'Caregiver',
                'Healthjoy',
                'Unsuccessful'
            ])
        }
    },

    outcomes: {
        phone: {
            waitlist: phoneOutcomesWaitlistPlannedOnhold,
            planned: phoneOutcomesWaitlistPlannedOnhold,
            onhold: phoneOutcomesWaitlistPlannedOnhold,
            active: {
                patient: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            'entered-in-error': {
                patient: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            finished: {
                patient: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            expired: {
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions([
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            cancelled: {
                patient: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions([
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            }
        },
        mobile: {
            waitlist: phoneOutcomesWaitlistPlannedOnhold,
            planned: phoneOutcomesWaitlistPlannedOnhold,
            onhold: phoneOutcomesWaitlistPlannedOnhold,
            active: {
                patient: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            'entered-in-error': {
                patient: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            finished: {
                patient: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            expired: {
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions([
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            cancelled: {
                patient: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions([
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            }
        },
        email: {
            waitlist: phoneOutcomesWaitlistPlannedOnhold,
            planned: phoneOutcomesWaitlistPlannedOnhold,
            onhold: phoneOutcomesWaitlistPlannedOnhold,
            active: {
                patient: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            'entered-in-error': {
                patient: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Routine Follow-Up',
                    'Requests to stop service',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            finished: {
                patient: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions(['Care Coordination', 'Other']),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            expired: {
                caregiver: genOptions([
                    'Requests Callback',
                    'Will call us back',
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions([
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            cancelled: {
                patient: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Records',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination',
                    'Other'
                ]),
                provider: genOptions([
                    'Caller Referred',
                    'Requests Callback',
                    'Will call us back',
                    'Care Coordination'
                ]),
                other: genOptions([
                    'Requests Records',
                    'Care Coordination',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    'Left Voicemail',
                    'Hung Up',
                    'No Answer',
                    'Wrong Number',
                    'Non-working Number',
                    'Care Coordination',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            }
        },
        home: {
            waitlist: homeOutcomesWaitlistPlannedOnhold,
            planned: homeOutcomesWaitlistPlannedOnhold,
            onhold: homeOutcomesWaitlistPlannedOnhold,
            active: {
                patient: genOptions([
                    'Planned Follow-Up',
                    'Unscheduled Follow-Up',
                    'Requests to stop service',
                    'Unable to complete visit - Rescheduled',
                    'Unable to complete visit - Needs appointment',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Planned Follow-Up',
                    'Unscheduled Follow-Up',
                    'Requests to stop service',
                    'Unable to complete visit - Rescheduled',
                    'Unable to complete visit - Needs appointment',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Planned Follow-Up',
                    'Unscheduled Follow-Up',
                    'Requests to stop service',
                    'Unable to complete visit - Rescheduled',
                    'Unable to complete visit - Needs appointment',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    "Didn't answer door",
                    'Patient and/or representative unavailable',
                    'Wrong address',
                    'Wrong Number',
                    'Schedule Error',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            'entered-in-error': {
                patient: genOptions([
                    'Planned Follow-Up',
                    'Unscheduled Follow-Up',
                    'Requests to stop service',
                    'Unable to complete visit - Rescheduled',
                    'Unable to complete visit - Needs appointment',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Planned Follow-Up',
                    'Unscheduled Follow-Up',
                    'Requests to stop service',
                    'Unable to complete visit - Rescheduled',
                    'Unable to complete visit - Needs appointment',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Planned Follow-Up',
                    'Unscheduled Follow-Up',
                    'Requests to stop service',
                    'Unable to complete visit - Rescheduled',
                    'Unable to complete visit - Needs appointment',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    "Didn't answer door",
                    'Patient and/or representative unavailable',
                    'Wrong address',
                    'Wrong Number',
                    'Schedule Error',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            finished: {
                patient: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    "Didn't answer door",
                    'Patient and/or representative unavailable',
                    'Wrong address',
                    'Wrong Number',
                    'Schedule Error',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            },
            expired: {
                caregiver: genOptions(['Requests Records', 'Other']),
                unsuccessful: genOptions([
                    "Didn't answer door",
                    'Patient and/or representative unavailable',
                    'Wrong address',
                    'Wrong Number',
                    'Schedule Error',
                    'Other'
                ])
            },
            cancelled: {
                patient: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Other'
                ]),
                healthjoy: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Other'
                ]),
                caregiver: genOptions([
                    'Requests Re-Enrollment',
                    'Requests Records',
                    'Other'
                ]),
                unsuccessful: genOptions([
                    "Didn't answer door",
                    'Patient and/or representative unavailable',
                    'Wrong address',
                    'Wrong Number',
                    'Schedule Error',
                    'Other'
                ]),
                vendor: genOptions([
                    'Requests Callback',
                    'Will Call Us Back',
                    'Care Coordination',
                    'Unable to Leave Message'
                ])
            }
        },
        bh: genOptions(['Care Coordination', 'Other'])
    }
};
